:host > .z-chip-container {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  padding: 0 calc(var(--space-unit) * 1.5);
  border: var(--border-size-small) solid var(--color-surface03);
  background-color: var(--color-surface01);
  border-radius: 14px;
  color: var(--color-default-text);
  fill: var(--color-default-icon);
  font-family: var(--font-family-sans);
  font-size: 14px;
  line-height: 28px;
}

:host > .z-chip-interactive {
  font-weight: var(--font-sb);
}

:host > .z-chip-container > button {
  padding: 0;
  border: none;
  margin-left: var(--space-unit);
  background-color: transparent;
  cursor: pointer;
}

:host > .z-chip-container > z-icon:first-child {
  margin-right: calc(var(--space-unit) / 2);
}

:host > .z-chip-container .interactive-icon {
  fill: var(--color-primary01-icon);
}

:host > .z-chip-container:not([aria-disabled]) .interactive-icon:hover {
  color: var(--color-hover-primary);
  fill: var(--color-hover-primary);
}

:host > .z-chip-container[aria-disabled],
:host > .z-chip-container[aria-disabled] z-icon {
  color: var(--color-disabled03);
  cursor: auto;
  fill: var(--color-disabled03);
}

:host > .z-chip-container[aria-disabled] {
  border: var(--border-size-small) solid var(--color-disabled01);
}

:host > .z-chip-container > button:focus:focus-visible {
  border-radius: 100%;
  box-shadow: var(--shadow-focus-primary);
  outline: none;
}

:host > button:not([disabled]):active:hover .interactive-icon {
  color: var(--color-primary01);
  fill: var(--color-primary01-icon);
}

:host > .z-chip-container > z-icon,
:host > .z-chip-container .interactive-icon {
  --z-icon-width: 22px;
  --z-icon-height: 22px;
}

/* :host type */
:host > .z-chip-container.default {
  min-height: 44px;
  border-radius: 22px;
  line-height: 44px;
}

:host > .z-chip-container.medium {
  min-height: 40px;
  border-radius: 22px;
  line-height: 40px;
}

:host > .z-chip-container.small {
  min-height: 36px;
  border-radius: 22px;
  line-height: 36px;
}

/* Desktop breakpoint */
@media (min-width: 1152px) {
  :host > .z-chip-container {
    font-size: 12px;
  }

  /* :host type */
  :host > .z-chip-container.default {
    min-height: 32px;
    border-radius: 16px;
    line-height: 32px;
  }

  :host > .z-chip-container.medium {
    min-height: 28px;
    border-radius: 16px;
    line-height: 28px;
  }

  :host > .z-chip-container.small {
    min-height: 24px;
    border-radius: 16px;
    line-height: 24px;
  }

  :host > .z-chip-container > z-icon,
  :host > .z-chip-container .interactive-icon {
    --z-icon-width: 14px;
    --z-icon-height: 14px;
  }
}
